// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3H0Cg","header":"ReportDetails_header__3czy1","title":"ReportDetails_title__3fsY5","left":"ReportDetails_left__8tKHZ"};